import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

const resources = {
  en: {
    translation: {
      mainTopic: 'Main Topic',
      verses: 'Verses',
      subtopic: 'Subtopic',
      subtopics: 'Subtopics',
      totalVerses: 'Total Verses',
      searchTopics: 'Search topics...',
      filterByLetter: 'Filter by letter',
      sortBy: 'Sort by',
      nameAZ: 'Name (A-Z)',
      nameZA: 'Name (Z-A)',
      topicNumber: 'Topic Number',
      noTopicsFound: 'No topics found',
      loading: 'Loading...',
      selectLanguage: 'Select Language',
      english: 'English',
      gujarati: 'ગુજરાતી (Gujarati)',
      hindi: 'हिन्दी (Hindi)',
      urdu: 'اردو (Urdu)',
      topicsTest: 'Topics',
      exploreTopics: 'Explore Quranic topics'
    }
  },
  gu: {
    translation: {
      mainTopic: 'મુખ્ય વિષય',
      verses: 'આયત',
      subtopic: 'ઉપવિષય',
      subtopics: 'ઉપવિષયો',
      totalVerses: 'કુલ આયતો',
      searchTopics: 'વિષયો શોધો...',
      filterByLetter: 'અક્ષર દ્વારા ફિલ્ટર કરો',
      sortBy: 'દ્વારા સૉર્ટ કરો',
      nameAZ: 'નામ (એ-ઝેડ)',
      nameZA: 'નામ (ઝેડ-એ)',
      topicNumber: 'વિષય નંબર',
      noTopicsFound: 'કોઈ વિષયો મળ્યા નથી',
      loading: 'લોડ થઈ રહ્યું છે...',
      selectLanguage: 'ભાષા પસંદ કરો',
      english: 'English',
      gujarati: 'ગુજરાતી (Gujarati)',
      hindi: 'हिन्दी (Hindi)',
      urdu: 'اردو (Urdu)',
      topicsTest: 'વિષયો',
      exploreTopics: 'કુરાનીક વિષયો'
    }
  },
  hi: {
    translation: {
      mainTopic: 'मुख्य विषय',
      verses: 'आयतें',
      subtopic: 'उपविषय',
      subtopics: 'उपविषय',
      totalVerses: 'कुल आयतें',
      searchTopics: 'विषय खोजें...',
      filterByLetter: 'अक्षर से फ़िल्टर करें',
      sortBy: 'द्वारा क्रमबद्ध करें',
      nameAZ: 'नाम (ए-ज़ेड)',
      nameZA: 'नाम (ज़ेड-ए)',
      topicNumber: 'विषय संख्या',
      noTopicsFound: 'कोई विषय नहीं मिले',
      loading: 'लोड हो रहा है...',
      selectLanguage: 'भाषा चुनें',
      english: 'English',
      gujarati: 'ગુજરાતી (Gujarati)',
      hindi: 'हिन्दी (Hindi)',
      urdu: 'اردو (Urdu)',
      topicsTest: 'विषय',
      exploreTopics: 'कुरानी विषय'
    }
  },
  ur: {
    translation: {
      mainTopic: 'اہم موضوع',
      verses: 'آیات',
      subtopic: 'ذیلی موضوع',
      subtopics: 'ذیلی موضوعات',
      totalVerses: 'کل آیات',
      searchTopics: 'موضوعات تلاش کریں...',
      filterByLetter: 'حرف کے ذریعے فلٹر کریں',
      sortBy: 'ترتیب دیں',
      nameAZ: 'نام (ا-ی)',
      nameZA: 'نام (ی-ا)',
      topicNumber: 'موضوع نمبر',
      noTopicsFound: 'کوئی موضوع نہیں ملا',
      loading: 'لوڈ ہو رہا ہے...',
      selectLanguage: 'زبان منتخب کریں',
      english: 'English',
      gujarati: 'ગુજરાતી (Gujarati)',
      hindi: 'हिन्दी (Hindi)',
      urdu: 'اردو (Urdu)',
      topicsTest: 'موضوعات',
      exploreTopics: 'قرآنی موضوعات '
    }
  }
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'en',
    debug: false,
    
    interpolation: {
      escapeValue: false, // React already escapes values
    },
    
    detection: {
      order: ['localStorage', 'navigator'],
      lookupLocalStorage: 'lang',
      caches: ['localStorage'],
    }
  });

// Set language attribute only (no RTL direction change)
i18n.on('languageChanged', (lng) => {
  document.documentElement.lang = lng;
});

// Initialize language on load
const currentLang = localStorage.getItem('lang') || 'en';
document.documentElement.lang = currentLang;

export default i18n;




